export const getTextColorByPaymentInfo = (statusColor: string | null) => {
    let textColor = 'textSecondary';

    if (statusColor === 'green') {
        textColor = 'success.main';
    } else if (statusColor === 'yellow') {
        textColor = 'warning.main';
    } else if (statusColor === 'red') {
        textColor = 'error.main';
    }

    return textColor;
};
